// extracted by mini-css-extract-plugin
module.exports = {"links":"FJPreviewLink_links__rS6U9","desc":"FJPreviewLink_desc__3UU0z"};